import { createInput } from '@formkit/vue'
import LDropzone from '@ui/components/LDropzone'

export const dropzone = createInput(LDropzone, {
  props: ['maxFiles', 'maxSize', 'multiple', 'parallelUploads', 'uploadMultiple', 'acceptedFiles', 'attachmentType'],
})
